module.exports = __webpack_public_path__ + "img/home_banner2.4610d2d5.png";